import { http, httpV2 } from "@/api/index";
const Qs = require("qs");

/**
 * @summary Solicita as configurações de sinais de tendência para um conjunto de ativos.
 * @param {array} meIds Identificadores dos elementos de monitoração do tipo turbina.
 * @returns Conjunto de sinais de tendência de suas respectivas turbinas.
 */
const GetSignalsByAssetsMonitoringElements = function(meIds)
{
	const ids = meIds.map(item => item.id);
	return httpV2.post("/TrendSignalSettings", ids);
};

export default { GetSignalsByAssetsMonitoringElements };
